// extracted by mini-css-extract-plugin
export var fileExt = "_sy-8";
export var fileIcon = "_sy-6";
export var fileLink = "_sy-5";
export var fileName = "_sy-7";
export var image = "_sy-1";
export var imageError = "_sy-3";
export var imageErrorIcon = "_sy-4";
export var imageLink = "_sy-0";
export var imageLoaded = "_sy-2";